import {
  reactQueryDelete,
  reactQueryGet,
  reactQueryPost,
  reactQueryPut,
} from "@/react/helpers/backendRequestHelpers";
import type { Params } from "@/react/helpers/urlHelpers";
import { internalApi } from "@/react/helpers/urlHelpers";
import type { Paywall } from "@/react/types";
import type { PaywallForm } from "../components/Paywalls/Admin/PaywallsAdmin/types/PaywallForm";

export interface PaywallFormRequest {
  paywall: Partial<PaywallForm>;
  publish: boolean;
}

export interface PaywallResponse extends Paywall {
  access_to_content_changed?: boolean;
}

const index = (params: Record<string, string>) => () => {
  Object.keys(params).forEach(key => {
    // eslint-disable-next-line sonarjs/different-types-comparison -- Disabled for plugin version update. Fix when possible.
    if (params[key] === null) {
      delete params[key];
    }
  });

  return reactQueryGet(
    internalApi.paywalls.index({
      params,
    }),
  );
};

const getPaywall = (
  paywallId: number,
  params: Params = {},
): Promise<PaywallResponse> =>
  reactQueryGet(internalApi.paywalls.show({ paywallId, params }));

const updatePaywall = (
  paywallId: number | undefined,
  params: Partial<PaywallFormRequest>,
): Promise<PaywallResponse> =>
  reactQueryPut(
    internalApi.paywalls.update({
      paywallId: paywallId,
    }),
    params,
  );

const deletePaywall = (
  paywallId: number | undefined,
): Promise<PaywallResponse> =>
  reactQueryDelete(
    internalApi.paywalls.delete({
      paywallId,
    }),
  );

const createPaywall = (params: PaywallFormRequest): Promise<PaywallResponse> =>
  reactQueryPost(internalApi.paywalls.create(), params);

export interface UpdateMemberAccessResponse {
  created_at: string;
  fingerprint: string;
  id: number;
  params: {
    paywall_id: string;
    paywall_spaces_fingerprint: string;
  };
  record_id: number;
  record_type: string;
}
const updateMemberAccess = (
  paywallId: number,
): Promise<UpdateMemberAccessResponse> =>
  reactQueryPost(internalApi.paywalls.updateMemberAccess({ paywallId }));

export const paywallApi = {
  index,
  getPaywall,
  createPaywall,
  updatePaywall,
  deletePaywall,
  updateMemberAccess,
};
